import { normalizeRuntimeTheme } from './normalize'
import type { RuntimeTheme } from './types'

/**
 * Loads public runtime theme from the theme API endpoint.
 *
 * @param apiBase Base API URL hosting `/themes/public`.
 * @returns Normalized runtime theme entity.
 */
export const fetchPublicRuntimeTheme = async (apiBase: string): Promise<RuntimeTheme> => {
  const response = await fetch(`${apiBase}/themes/public`)
  if (!response.ok) {
    const text = await response.text()
    throw new Error(text || `Errore caricamento tema (${response.status})`)
  }
  const data = await response.json()
  return normalizeRuntimeTheme(data?.theme)
}
